module.exports = __webpack_public_path__ + "static/media/slider.dc5358c5.svg";